import { render } from "./MngDepartment.vue?vue&type=template&id=42d659ae&scoped=true&ts=true"
import script from "./MngDepartment.vue?vue&type=script&lang=ts"
export * from "./MngDepartment.vue?vue&type=script&lang=ts"

import "./MngDepartment.vue?vue&type=style&index=0&id=42d659ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d659ae"]])

export default __exports__